// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","wrapper":"styles_wrapper__yfEdN","container":"styles_container___xVT5","subtitle":"styles_subtitle__jbZWY"};